import { svg } from "lit";
const icon = svg `<path d="M3.55383 17.5478L2.5 16.494L9.3519 9.59208L13.3519 13.5921L18.9654 8.0478H16V6.54785H21.5V12.0478H20V9.10163L13.3519 15.7497L9.3519 11.7497L3.55383 17.5478Z" fill="currentColor"/>`;
export default icon;
